// extracted by mini-css-extract-plugin
module.exports =  {"content":"NfxyUxQBfps7JulwIrKC","column":"a1BbvOA201YsaYHVgOGm"};